import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TextControl } from '@shared/ui/controls/text-control.model';
import { BenchTemplateItem } from '../../../shared/interfaces/entities/bench-template-item.interface';
import { AvailableItemsSelect } from '../../../shared/ui/select-controls/available-items-select.model';
import { AvailableItemFilter } from '../../../shared/interfaces/select-filters/available-item.filter.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { ItemUnique } from '../../../shared/interfaces/entities/item-unique.interface';

@Component({
  selector: 'app-reassign-items',
  templateUrl: './reassign-items.component.html',
  styleUrls: ['./reassign-items.component.css'],
  standalone: false
})
export class ReassignItemsComponent implements OnInit {
  @Input() entity: ItemUnique;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  public form: FormGroup;
  submitted: boolean = false;
  availableItems: AvailableItemsSelect;
  id: number;
  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.availableItems = new AvailableItemsSelect("Test", "", null);

    var organizationId: AvailableItemFilter = {
      OrganizationId: this.auth.getOrganizationId()
    };
    this.availableItems.filters = organizationId;

    this.form = this.fb.group({
      id: this.id,
      itemUniqnumId: null,
    });
  }

  save(): void {
    this.submitted = true;

    var itemUniqnumId = this.availableItems.getValue();

    this.form.controls['itemUniqnumId'].setValue(itemUniqnumId);

    this.submitForm.emit(this.form);
  }
}
